{
  "$id": "module://terms-conditions",
  "title": "Terms and Conditions",
  "description": "Shared field catalog for Terms & Conditions Document and Terms & Conditions Text",
  "type": "object",
  "properties": {
    "grantDocumentName": {
      "type": "string",
      "title": "Name",
      "widget": "text",
      "required": true,
      "noBlank": true
    },
    "description": {
      "type": "string",
      "title": "Description",
      "widget": "textarea",
      "adapterProps": { "rows": 4 }
    },
    "document": {
      "type": "file",
      "title": "Upload Documents",
      "widget": "file-upload",
      "required": true,
      "fileUpload": {
        "multiple": false,
        "maxFiles": 1,
        "submit": {
          "selection": "first",
          "arrayKey": "document"
        }
      }
    },
    "grantTermsAndConditionText": {
      "type": "string",
      "title": "Terms and Condition Text",
      "widget": "richtext",
      "required": true
    },
    "planGrantDocumentId": {
      "$ref": "module://grant#properties/planGrantDocumentId"
    },
    "planId": {
      "$ref": "module://grant#properties/planId"
    },
    "documentType": {
      "$ref": "module://grant#properties/documentType"
    }
  }
}
